const defaultBtnClass =
  "px-2 py-1 rounded-[4px] bg-[#E6E7E8] text-[11px] font-inter-semibold text-[#808285]";
const activeBtnClass =
  "px-2 py-1 rounded-[4px] bg-white text-[11px] font-inter-semibold text-[#252526]";

const DetailTabArchived = ({ countListing, handleMoveTo, status }) => {
  const _handleClickTab = (tab) => {
    handleMoveTo(tab);
  };

  return (
    <div className="flex items-center rounded-[4px] justify-center p-0.5 bg-[#E6E7E8] w-fit">
      <button
        onClick={() => _handleClickTab("interested")}
        className={status === "interested" ? activeBtnClass : defaultBtnClass}
      >
        Tertarik
      </button>
      <button
        onClick={() => _handleClickTab("not_interested")}
        className={
          status === "not_interested" ? activeBtnClass : defaultBtnClass
        }
      >
        Tidak Tertarik
      </button>
    </div>
  );
};

export default DetailTabArchived;
